var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100vw","background-color":"#f8f8f8"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }